"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.CultureContext = react_1.default.createContext({
    Name: 'us',
    DateTimeFormat: {
        MomentShortDatePattern: 'MM/DD/YYYY',
        MomentShortYearDatePattern: 'MM/DD/YY',
        MomentShortYearDateTimePattern: 'MM/DD/YY h:mm A'
    },
    NumberFormat: {
        NumberDecimalSeparator: '.',
        NumberGroupSeparator: ','
    }
});
//# sourceMappingURL=culture-context.js.map